import React from 'react';
import Depot from '../../_shared/depot';
const removeFillFromSVG = (element) => {
    const { fill, children, ...rest } = element.props;
    const newChildren = Array.isArray(children)
        ? children.map((child) => {
            const { fill: fillChildren, ...restChildren } = child.props;
            return { ...child, props: restChildren };
        })
        : children;
    return { ...element, props: { children: newChildren, ...rest } };
};
/* Preparing the content to remove any fill in the paths and recomposing the svg tag ourselves */
export function removeFillFromReactComponent(source) {
    let children;
    React.Children.forEach(source.content, (child) => {
        const childrenArray = Array.isArray(child.props.children)
            ? child.props.children
            : [child.props.children];
        children = childrenArray.map((item) => removeFillFromSVG(item));
    });
    return children;
}
const Icon = ({ source, size = 24, fill = 'currentColor', title, description, ...commonProps }) => {
    const svgChildren = removeFillFromReactComponent(source);
    const altText = (source === null || source === void 0 ? void 0 : source.alt) || 'Icon';
    return Depot.createElement('svg', {
        role: 'img',
        id: altText,
        ...commonProps,
        fill,
        viewBox: '0 0 24 24',
        height: `${size}px`,
        width: `${size}px`,
    }, React.createElement(React.Fragment, null,
        React.createElement("title", null, title !== null && title !== void 0 ? title : altText),
        React.createElement("desc", null, description !== null && description !== void 0 ? description : altText),
        svgChildren));
};
export default Icon;
//# sourceMappingURL=index.js.map